// Image structured data shared by the articles and the landing pages.
import { plainInline } from "@/content/guides/body";
import type { OgImage } from "./site";
import type { PageImage } from "./pages";

/** schema.org ImageObjects: the link-preview card first (Google's preferred 1.91:1), then the images on the page. */
export const imageObjects = (origin: string, og: OgImage, images: PageImage[]) => [
  { "@type": "ImageObject", url: `${origin}${og.path}`, width: og.width, height: og.height, caption: og.alt },
  ...images.map((i) => ({
    "@type": "ImageObject",
    url: `${origin}${i.path}`,
    contentUrl: `${origin}${i.path}`,
    width: i.width,
    height: i.height,
    caption: plainInline(i.caption ?? i.alt),
    description: i.alt,
  })),
];
